var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320 21.333h-234.67c-23.466 0-42.666 19.2-42.666 42.667v277.33c0 11.734 9.6 21.334 21.333 21.334s21.333-9.6 21.333-21.334v-256c0-11.733 9.6-21.333 21.334-21.333h213.33c11.733 0 21.333-9.6 21.333-21.333 0-11.734-9.6-21.334-21.333-21.334zm85.333 85.334h-234.67c-23.467 0-42.667 19.2-42.667 42.666v298.67c0 23.467 19.2 42.667 42.667 42.667h234.67c23.467 0 42.667-19.2 42.667-42.667v-298.67c0-23.466-19.2-42.666-42.667-42.666zm-21.333 341.33h-192c-11.733 0-21.333-9.6-21.333-21.333v-256c0-11.734 9.6-21.334 21.333-21.334h192c11.733 0 21.333 9.6 21.333 21.334v256c0 11.733-9.6 21.333-21.333 21.333z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.790dbc3401dc779d2919932b080f1599.svg";
export { ForwardRef as ReactComponent };